/**
 * PoC期間の上限に関するユーティリティ。
 *
 * PoC終了日（POC_END_DATE）がサービスを利用できる最終日で、チェックイン日・空港到着日・
 * カウンター預け入れ日はこの日までしか選択できない。
 * チェックアウト日には上限を設けない（預け入れはチェックイン当日か前日のため、配送はPoC終了日までに終わる。
 * 年末をまたぐ宿泊も申し込めるようにする）。
 *
 * note: PoC期間を延長する際は POC_END_DATE_PARTS を更新する。
 *       この制限は画面（カレンダーとバリデーション）のみで、APIには上限チェックを持たせていない。
 *
 * 日付はすべて `YYYY-MM-DD` 形式の文字列（＝日本時間のカレンダー日付）として扱う。
 */
import { toDateString } from './pickupDateRange';

/**
 * PoC終了日（= サービスを利用できる最終日）。月は1始まり。
 *
 * note: 実施期間は2026-12-25（金）チェックイン分まで（AT_DEV-5680）。
 */
const POC_END_DATE_PARTS = { year: 2026, month: 12, day: 25 } as const;

/**
 * PoC終了日を Date で返す（ローカル基準・00:00）。
 * チェックイン日・空港到着日・カウンター預け入れ日の上限として使用する。
 */
export const getPocEndDate = (): Date =>
    new Date(POC_END_DATE_PARTS.year, POC_END_DATE_PARTS.month - 1, POC_END_DATE_PARTS.day);

/** PoC終了日（`YYYY-MM-DD`） */
export const POC_END_DATE = toDateString(getPocEndDate());

/**
 * 日付が上限日以前（PoC期間内）かを判定する。
 * 空の場合は判定不能として true（範囲内扱い）を返し、必須チェックに委ねる。
 *
 * @param date 判定対象の日付（`YYYY-MM-DD`）
 * @param lastDate 上限日（`YYYY-MM-DD`）。既定はPoC終了日
 */
export const isWithinPocPeriod = (date: string, lastDate: string = POC_END_DATE): boolean => {
    if (!date) return true;
    return date <= lastDate;
};

/** 2つの上限日のうち早い方を返す（一方が未指定ならもう一方） */
export const earlierDate = (a: Date | undefined, b: Date): Date => {
    if (!a) return b;
    return a.getTime() < b.getTime() ? a : b;
};
